import { cn } from "@/lib/utils";

type FormNoticeProps = {
  className?: string;
  message: string;
  role?: "alert" | "status";
  tone?: "error" | "success";
};

export function FormNotice({
  className,
  message,
  role = "alert",
  tone = "error",
}: FormNoticeProps) {
  return (
    <div
      role={role}
      className={cn(
        "rounded-[1rem] border px-4 py-3 text-center font-sans text-[0.92rem] font-medium leading-relaxed shadow-[0_14px_40px_rgb(31_10_24/6%)]",
        tone === "success"
          ? "border-[rgb(242_164_53_/_18%)] bg-[color-mix(in_srgb,#ffffff_82%,#f9e3b8)] text-[#4a193c]"
          : "border-[rgb(118_42_92_/_12%)] bg-[color-mix(in_srgb,#fff7f8_86%,#f4dbc2)] text-pink-dark",
        className,
      )}
    >
      {message}
    </div>
  );
}
